import React from "react";
import "./styles.css";

function HomePage() {
  return (
    <>
      <div className="homeContainer">
        <div className="homeWrapper">
          <h1>Welcome</h1>
          <h2>
            Prove your worth in a test of knowledge against other challengers in
            this fast-paced quiz game
          </h2>
          <h2>Review the buttons above to begin</h2>
          <h2>Good luck</h2>
        </div>
      </div>
    </>
  );
}

export default HomePage;
